import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "rounded-xl bg-[#242B59] p-2 text-[#48DDC3]" }
const _hoisted_4 = { class: "text-2xl font-bold text-[#242B59]" }
const _hoisted_5 = { class: "mt-1 text-sm text-[#626468]" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["CurrencyDollarIcon"], { class: "h-6 w-6" })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('aura.processingCosts.title')), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('aura.processingCosts.description')), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("button", {
      class: "flex w-full items-center justify-center gap-2 rounded-lg border border-[#E5E7EB] bg-white px-3 py-2 text-sm font-medium text-[#242B59] shadow-sm hover:bg-[#F8FAFC] sm:w-auto",
      disabled: $props.isLoading,
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('refresh')))
    }, [
      _createVNode($setup["RefreshIcon"], {
        class: _normalizeClass(["h-4 w-4", $props.isLoading ? 'animate-spin' : ''])
      }, null, 8 /* PROPS */, ["class"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('aura.processingCosts.refresh')), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_6)
  ]))
}